export default __webpack_public_path__ + "static/media/salad.d1f5fdaa.jpg";